import { CustomEvents } from '@/constants/events'

const TIMEOUT = 10000

let base64Buffer = ''
let fileName = ''
let fileType = ''
let timer: NodeJS.Timeout | undefined = undefined


function shareError() {
  clearTimeout(timer)
  clearData()
  const event = new CustomEvent(CustomEvents.SHARE_ERROR)
  window.dispatchEvent(event)
}

function startShareFile(name: string, type: string) {
  fileName = name
  fileType = type
  base64Buffer = ''
  clearTimeout(timer)
  timer = setTimeout(shareError, TIMEOUT)
  const event = new CustomEvent(CustomEvents.START_SHARE_FILE)
  window.dispatchEvent(event)
}

function clearData() {
  fileName = ''
  fileType = ''
  base64Buffer = ''
}

function receiveBase64Chunk(chunk: string) {
  base64Buffer += chunk
  clearTimeout(timer)
  timer = setTimeout(shareError, TIMEOUT)
}

function completeShareFile(jids?: string[]) {
  if (!fileName || !fileType || !base64Buffer) {
    return
  }
  clearTimeout(timer)
  const bytes = base64ToUint8Array(base64Buffer)
  const file = new File([bytes], fileName, { type: fileType })
  const event = new CustomEvent(CustomEvents.SHARE_FILE, {
    detail: {
      file,
      jids
    }
  })
  window.dispatchEvent(event)
  clearData()
}

function base64ToUint8Array(base64: string) {
  const binaryString = atob(base64)
  const len = binaryString.length
  const bytes = new Uint8Array(len)
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}

// function testShareFile(){
//   startShareFile('text', 'text/plain')
//
//   const text = "Hello, World!"
//   const base64 = btoa(text)
//   receiveBase64Chunk(base64)
//   completeShareFile(['16980@dev-xmpp.youchat.com'])
// }


window.startShareFile = startShareFile
window.receiveBase64Chunk = receiveBase64Chunk
window.completeShareFile = completeShareFile
